import {
    AfterViewInit, Component, CUSTOM_ELEMENTS_SCHEMA, ElementRef, EventEmitter,
    HostListener,
    Input, OnDestroy, Output, ViewChild
} from '@angular/core';
import { fromEvent, Subject, Subscription, takeUntil } from 'rxjs';
import { v4 as uuid } from 'uuid';

import { NgClass } from '@angular/common';
import { ListenersRegistry } from '@skylab-shared/utils';
import { ValidationAreaComponent } from '../validation/validation-area/validation-area.component';
import { PanelEventNames, PanelService } from './panel.service';

type AreaValidationInfo = {isError: boolean, isWarning: boolean, areaId: string};

@Component({
    selector: 'skl-panel',
    templateUrl: './panel.component.html',
    imports: [NgClass, ValidationAreaComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class PanelComponent extends ListenersRegistry(class {}) implements AfterViewInit, OnDestroy {
    @ViewChild(ValidationAreaComponent) private area!: ValidationAreaComponent;

    @Input() public headerText!: string;

    @Input() public headerVisible = false;

    @Input() public notifySizeChange = false;

    @Input() public isOpen = false;

    @Output() public onOpen = new EventEmitter<void>();

    private readonly $element: HTMLElement;
    private areaEventId!: string;

    public wrapperId!: string;
    public readonly panelId = uuid();
    public isWarning = false;
    public isError = false;
    private destroy$ = new Subject<void>();

    private resizeSubscription!: Subscription;

    public constructor(
        private readonly element: ElementRef,
        private readonly panelService: PanelService
    ) {
        super();
        this.$element = this.element.nativeElement;
    }

    public ngOnInit(): void {
        this.$element.setAttribute('panel-id', this.panelId);
        this.$element.setAttribute('validation-area-id', this.panelId);
    }

    public ngAfterViewInit(): void {
        this.wrapperId = this.$element.closest('[panel-wrapper-id]')?.getAttribute('panel-wrapper-id') ?? '';

        if (this.notifySizeChange) {
            this.resizeSubscription = fromEvent(window, 'resize').subscribe(_ => {
                this.panelService.notify(
                    this.wrapperId,
                    this.panelId,
                    PanelEventNames.SizeChanged,
                    window.innerHeight,
                );
            });
        }

        this.area.areaViolation$.pipe(takeUntil(this.destroy$)).subscribe(data => {
            this.updateViolationsInfo(data);
        });
    }


    public ngOnDestroy(): void {
        this.deregisterAllListeners();
        this.resizeSubscription?.unsubscribe();
        this.destroy$.next();
    }

    public updateViolationsInfo(data: AreaValidationInfo): void {
        if (!data) return;
        this.isError = data.isError;
        this.isWarning = data.isWarning;
        this.$element.classList.toggle('panel-error', this.isError);
        this.$element.classList.toggle('panel-warning', this.isWarning);
    }

    @HostListener('insPanelStateChange', ['$event.target'])
    public onSelect(element: any): void {
        const open = element?.open;
        this.isOpen = open;
        if (this.isOpen) {
            this.onOpen.emit();
        }
    }
}
